import { render, staticRenderFns } from "./PaginationGoto.vue?vue&type=template&id=36b0ac38"
import script from "./PaginationGoto.vue?vue&type=script&lang=js"
export * from "./PaginationGoto.vue?vue&type=script&lang=js"
import style0 from "./PaginationGoto.vue?vue&type=style&index=0&id=36b0ac38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports